"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.ItemButtons = exports.HeaderContent = exports.Header = exports.Item = exports.IconWrap = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.IconWrap = styled_components_1.default.span `
  position: relative;
  display: flex;
  align-items: center;
  height: ${(0, wl_ui_kit_1.getSizeBy)(9)};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
`;
exports.Item = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-bottom: ${(0, wl_ui_kit_1.getSizeBy)(4)};

  & + & {
    margin-top: ${(0, wl_ui_kit_1.getSizeBy)(5)};
  }
`;
const BorderColorCSS = (0, styled_components_1.css) `
  border-color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
`;
exports.Header = styled_components_1.default.div `
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-between;
  min-height: ${(0, wl_ui_kit_1.getSizeBy)(11)};
  padding: 0 ${(0, wl_ui_kit_1.getSizeBy)(5)};
  background: ${(0, wl_ui_kit_1.getColor)('background')};
  border: 1px solid;
  border-top-left-radius: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  border-top-right-radius: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  ${BorderColorCSS};
`;
exports.HeaderContent = styled_components_1.default.div ``;
exports.ItemButtons = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  gap: ${(0, wl_ui_kit_1.getSizeBy)(1)};
  margin-right: -${(0, wl_ui_kit_1.getSizeBy)(1)};
`;
exports.Content = styled_components_1.default.div `
  padding: ${(0, wl_ui_kit_1.getSizeBy)(5)};
  padding-bottom: ${(0, wl_ui_kit_1.getSizeBy)(6)};
  border: 1px solid;
  border-top: none;
  border-bottom-right-radius: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  border-bottom-left-radius: ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  ${BorderColorCSS};
`;
//# sourceMappingURL=styled.js.map